import React, { useState } from "react";
import { Link } from "react-router-dom";
import PATH from "./../../constants/routes";
import { useParams } from "react-router-dom";
import { AiOutlineStar } from "react-icons/ai";
import { BiPlay } from "react-icons/bi";
import { BsDot } from "react-icons/bs";
import { FaLock } from "react-icons/fa";

import VideoCard from "./VideoCard";
import "./VideoContents.scss";

const videosPrototype = [
  {
    id: 1,
    videoThumbnail: "",
    videoTitle: "Introduction",
    progressComplete: 40,
    rating: 4.2,
    completed: false,
    unlocked: true,
    videoLength: 20,
  },
  {
    id: 2,
    videoThumbnail: "",
    videoTitle: "advance",
    progressComplete: 40,
    rating: 3.8,
    completed: false,
    unlocked: true,
    videoLength: 5,
  },
  {
    id: 3,
    videoThumbnail: "",
    videoTitle: "How to fetch api?",
    progressComplete: 40,
    rating: 2,
    completed: false,
    unlocked: false,
    videoLength: 1,
  },
];

export default function VideoContent() {
  const [videos, setVideos] = useState<any[]>(videosPrototype);
  const { subject_id } = useParams();

  const renderVideosList = () => {
    return videos.map((video, index) => {
      return (
        <Link to={`/${PATH.VIDEOS}/${subject_id}/${video.id}`} key={index}>
          <VideoCard video={video} />
        </Link>
      );
    });
  };

  return (
    <div className="unit_container">
      <h4 className="unit_title">C Programming</h4>
      <ul className="video_container">{renderVideosList()}</ul>
    </div>
  );
}
